import { Variable } from "../models/Variable";
import { API } from "./API";

export const loadVariablesByGame = (gameId: number): Promise<Variable[]> => {
  return API.get<Variable[]>(`variable/${gameId}`);
};
